<template>
    <div class="home">
        <div class="content">
            <div class="image-container">
                <img class="home-image" :alt="$t('home:altTag')" src="@/assets/images/backgrounds/splashscreen.svg">
            </div>
            <div class="copy-container">
                <h1 class="title" v-html="$t('home:title')"></h1>
                <div class="description" v-html="$t('home:description')"></div>
                <div class="btn-panel">
                    <button @click="goToNext" class="btn btn-red"> {{ $t('general:ctaStartGeneral') }}
                        <SvgIcon type="horizontal_line_white" class="arrowicon line_white"/>
                        <SvgIcon type="icon_arrow_right" class="arrowicon chevron"/>
                    </button>
                    <button @click="goToLink()" class="btn btn-white" target="_blank">
                        {{ $t('general:contactUs') }}
                        <SvgIcon type="horizontal_line_red" class="arrowicon line_red"/>
                        <SvgIcon type="icon_arrow_right_red" class="arrowicon chevron"/>
                    </button>
                </div>
            </div>
          </div>
      </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import current from '@/mixins/current'
import adobeTracking from '@/mixins/adobeTracking'
import SvgIcon from '@/components/SvgIcon'

export default {
    name: 'Home',
    mixins: [current, adobeTracking],
    components: {
        SvgIcon
    },
    computed: {
        ...mapGetters('app', [
            'isFormStarted'
        ])
    },
    methods: {
        ...mapActions('app', [
            'setFormStart'
        ]),
        goToLink() {
            window.open(this.$t('home:contactUsUrl'))
        },
        goToNext() {
            if (!this.isFormStarted) {
                this.trackFormStart()
                this.setFormStart(true)
            }
            this.trackCTAClick({
                CTAName: 'Start your check',
                CTALink: 'Startyourcheck'
            })
            this.$router.push({
                name: 'questionnaire'
            })
        }
    },
    mounted() {
        this.trackPageView()
    }
}
</script>
